import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { EventAnnouncementCard } from '~/features/events/components/event-announcement-card'
import { EventCheckinQrCard } from '~/features/events/components/event-checkin-qr-card'
import { EventDetailHeader } from '~/features/events/components/event-detail-header'
import {
  EventAdvancedCard,
  EventDetailsCard,
} from '~/features/events/components/event-detail-overview'
import { EventNumbersCard } from '~/features/events/components/event-numbers-card'
import { EventRegistrationCard } from '~/features/events/components/event-registration-card'
import { EventTicketsCard } from '~/features/events/tickets/event-tickets-card'
import { parsePayoutReturn } from '~/features/events/tickets/payout-return'
import { EventShareLinksCard } from '~/features/share-links/event-share-links-card'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import { DetailPageGrid } from '~/widgets/detail-page-grid'

export const Route = createFileRoute('/dashboard/events/$eventId/')({
  validateSearch: (search: Record<string, unknown>) => ({
    payouts: parsePayoutReturn(search.payouts),
  }),
  component: EventDetail,
})

function EventDetail() {
  const { eventId } = Route.useParams()
  const { payouts } = Route.useSearch()
  return (
    <div className="mx-auto w-full max-w-7xl space-y-6">
      <Button asChild variant="ghost" size="sm" className="w-fit">
        <Link to="/dashboard/events">
          <ArrowLeft className="h-4 w-4" />
          {m.backToEvents()}
        </Link>
      </Button>
      <EventDetailHeader eventId={eventId} />
      <DetailPageGrid
        top={<EventNumbersCard eventId={eventId} />}
        side={
          <>
            <EventAnnouncementCard eventId={eventId} />
            <EventCheckinQrCard eventId={eventId} />
            <EventShareLinksCard eventId={eventId} />
          </>
        }
      >
        <EventDetailsCard eventId={eventId} />
        <EventTicketsCard eventId={eventId} payoutReturn={payouts} />
        <EventRegistrationCard eventId={eventId} />
        <EventAdvancedCard eventId={eventId} />
      </DetailPageGrid>
    </div>
  )
}
